module.exports = __webpack_public_path__ + "img/satellite_big.6f5068ac.png";